import dynamic from "next/dynamic";

const Grid = dynamic(() => import("@mui/material/Grid"), { loading: () => null });
const MDBox = dynamic(() => import('/components/MDBox'), { loading: () => null });
const ALLDVideo = dynamic(() => import('/examples/ALLDVideo'), { loading: () => null });

export default function DialogVidDisplay({array, keyPrefix, viewMode}) {
  return (
    <MDBox position="relative" zIndex={10} px={{ xs: 1, sm: 0 }}>
      <Grid container spacing={3} justifyContent="center">
        {array.map((row) => (
          <Grid item xs={12} lg={viewMode} key={`${keyPrefix}-${row.id}`}>
            <ALLDVideo row={row} />
          </Grid>
        ))}
      </Grid>
    </MDBox>
  )
}